import React, { useState, useEffect, useRef } from 'react'
import { Form, Button, Row, Col, Container, Card, Modal, Badge, Tab, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import Loader from '../components/Loader'
import Message from '../components/Message'
import {
    createTournament, updateTournament, getTournamentDetails,
    createTournamentDay, updateTournamentDay, deleteTournamentDay,
    createTournamentAward, deleteTournamentAward,
    createTournamentContest, deleteTournamentContest,
    listTournamentRegistrations, addTournamentRegistration,
    updateTournamentRegistration, deleteTournamentRegistration,
    listTournamentTeams, generateTournamentTeams, clearTournamentTeams,
    addTournamentTeam,
    addTeamMember, removeTeamMember,
    updateTournamentAward, updateTournamentContest, updateTournamentWinner,
} from '../actions/tournamentActions'
import { listCourses, getCourseDetails } from '../actions/courseActions'
import { listAwards } from '../actions/awardActions'
import { listContests } from '../actions/contestActions'
import { listUsers } from '../actions/userActions'
import {
    TOURNAMENT_CREATE_RESET, TOURNAMENT_UPDATE_RESET, TOURNAMENT_DETAILS_RESET,
    TOURNAMENT_DAY_CREATE_RESET, TOURNAMENT_DAY_UPDATE_RESET,
    TOURNAMENT_AWARD_CREATE_RESET, TOURNAMENT_CONTEST_CREATE_RESET,
    TOURNAMENT_REG_ADD_RESET,
} from '../constants/tournamentConstants'

function TournamentEditScreen() {
    const { id }      = useParams()
    const isEditing   = Boolean(id)
    const dispatch    = useDispatch()
    const navigate    = useNavigate()
    const populatedId = useRef(null)

    // â”€â”€ Tournament fields â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const [name, setName]                       = useState('')
    const [type, setType]                       = useState('BNB')
    const [location, setLocation]               = useState('')
    const [tStatus, setTStatus]                 = useState('draft')
    const [teams, setTeams]                     = useState('Singles')
    const [entryFee, setEntryFee]               = useState('0')
    const [maxPlayers, setMaxPlayers]           = useState('')
    const [membershipRequired, setMembershipRequired] = useState(true)
    const [photoGalleryUrl, setPhotoGalleryUrl] = useState('')
    const [description, setDescription]         = useState('')
    const [descPreview, setDescPreview]         = useState(false)
    const [accountant, setAccountant]           = useState('')
    // Google Maps
    const [mapLocation, setMapLocation] = useState('')
    // Images
    const [logoFile, setLogoFile]           = useState(null)
    const [imageDtFile, setImageDtFile]     = useState(null)
    const [imageMbFile, setImageMbFile]     = useState(null)
    const [logoPreview, setLogoPreview]     = useState('')
    const [imageDtPreview, setImageDtPreview] = useState('')
    const [imageMbPreview, setImageMbPreview] = useState('')
    // Active tab
    const [activeTab, setActiveTab] = useState('jobs')
    // Players tab
    const [showRegModal, setShowRegModal]   = useState(false)
    const [regUser, setRegUser]             = useState('')
    const [regStatus, setRegStatus]         = useState('registered')
    const [regFilter, setRegFilter]         = useState('all')
    // Teams tab drag state
    const [dragPlayerId, setDragPlayerId]         = useState(null)
    const [dragFromMemberId, setDragFromMemberId] = useState(null)
    const [dragOverTeamId, setDragOverTeamId]     = useState(null)
    // Teams tab generate count input
    // (removed — using Add Team button instead)
    // â”€â”€ Round modal fields â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const [showDayModal, setShowDayModal] = useState(false)
    const [editingDay, setEditingDay]     = useState(null)
    const [dayCourse, setDayCourse]       = useState('')
    const [dayDate, setDayDate]           = useState('')
    const [dayStartTime, setDayStartTime] = useState('')
    const [dayEndTime, setDayEndTime]     = useState('')
    const [dayOrder, setDayOrder]         = useState(1)
    // â”€â”€ Award modal fields â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const [showAwardModal, setShowAwardModal] = useState(false)
    const [selectedAward, setSelectedAward]   = useState('')
    // â”€â”€ Contest modal fields â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const [showContestModal, setShowContestModal] = useState(false)
    const [selectedContest, setSelectedContest]   = useState('')
    const [selectedRound, setSelectedRound]       = useState('')
    const [contestHole, setContestHole]           = useState('')
    const [contestPrize, setContestPrize]         = useState('')

    // â”€â”€ Redux â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const tournamentDetails = useSelector(state => state.tournamentDetails)
    const { loading: loadingDetails, error: errorDetails, tournament } = tournamentDetails

    const tournamentCreate = useSelector(state => state.tournamentCreate)
    const { loading: loadingCreate, error: errorCreate, success: successCreate } = tournamentCreate

    const tournamentUpdate = useSelector(state => state.tournamentUpdate)
    const { loading: loadingUpdate, error: errorUpdate, success: successUpdate } = tournamentUpdate

    const tournamentDayCreate = useSelector(state => state.tournamentDayCreate)
    const { loading: loadingDayCreate, error: errorDayCreate, success: successDayCreate } = tournamentDayCreate

    const tournamentDayUpdate = useSelector(state => state.tournamentDayUpdate)
    const { loading: loadingDayUpdate, error: errorDayUpdate, success: successDayUpdate } = tournamentDayUpdate

    const tournamentDayDelete = useSelector(state => state.tournamentDayDelete)
    const { error: errorDayDelete, success: successDayDelete } = tournamentDayDelete

    const tournamentAwardCreate = useSelector(state => state.tournamentAwardCreate)
    const { loading: loadingAwardCreate, error: errorAwardCreate, success: successAwardCreate } = tournamentAwardCreate

    const tournamentAwardDelete = useSelector(state => state.tournamentAwardDelete)
    const { error: errorAwardDelete, success: successAwardDelete } = tournamentAwardDelete

    const tournamentContestCreate = useSelector(state => state.tournamentContestCreate)
    const { loading: loadingContestCreate, error: errorContestCreate, success: successContestCreate } = tournamentContestCreate

    const tournamentContestDelete = useSelector(state => state.tournamentContestDelete)
    const { error: errorContestDelete, success: successContestDelete } = tournamentContestDelete

    const tournamentRegList = useSelector(state => state.tournamentRegList)
    const { loading: loadingRegList, registrations = [], error: errorRegList } = tournamentRegList

    const tournamentRegAdd = useSelector(state => state.tournamentRegAdd)
    const { loading: loadingRegAdd, success: successRegAdd, error: errorRegAdd } = tournamentRegAdd

    const tournamentRegUpdate = useSelector(state => state.tournamentRegUpdate)
    const { success: successRegUpdate } = tournamentRegUpdate

    const tournamentRegDelete = useSelector(state => state.tournamentRegDelete)
    const { success: successRegDelete } = tournamentRegDelete

    const tournamentTeamsList = useSelector(state => state.tournamentTeamsList)
    const { loading: loadingTeams, teams: tournTeams = [] } = tournamentTeamsList

    const tournamentTeamsGenerate = useSelector(state => state.tournamentTeamsGenerate)

    const tournamentTeamAdd = useSelector(state => state.tournamentTeamAdd)
    const { loading: loadingTeamAdd } = tournamentTeamAdd

    const tournamentAwardUpdate = useSelector(state => state.tournamentAwardUpdate)
    const { success: successAwardUpdate } = tournamentAwardUpdate

    const tournamentContestUpdate = useSelector(state => state.tournamentContestUpdate)
    const { success: successContestUpdate } = tournamentContestUpdate

    const tournamentWinnerUpdate = useSelector(state => state.tournamentWinnerUpdate)
    const { success: successWinnerUpdate } = tournamentWinnerUpdate

    const courseList = useSelector(state => state.courseList)
    const { courses = [] } = courseList

    const awardList = useSelector(state => state.awardList)
    const { awards = [] } = awardList

    const contestList = useSelector(state => state.contestList)
    const { contests = [] } = contestList

    const userList = useSelector(state => state.userList)
    const { users = [] } = userList

    const courseDetails = useSelector(state => state.courseDetails)
    const { course: modalCourse } = courseDetails

    // â”€â”€ Effects â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    // 1. Fetch on mount
    useEffect(() => {
        dispatch(listCourses())
        dispatch(listAwards())
        dispatch(listContests())
        dispatch(listUsers())
        if (isEditing) {
            dispatch(getTournamentDetails(id))
            dispatch(listTournamentRegistrations(id))
            dispatch(listTournamentTeams(id))
        }
        return () => { dispatch({ type: TOURNAMENT_DETAILS_RESET }) }
    }, [id])

    // 2. Populate form once (guarded by populatedId ref)
    useEffect(() => {
        if (tournament && tournament.id && tournament.id !== populatedId.current) {
            populatedId.current = tournament.id
            setName(tournament.name || '')
            setType(tournament.type || 'BNB')
            setLocation(tournament.location || '')
            setTStatus(tournament.status || 'draft')
            setTeams(tournament.teams || 'Singles')
            setEntryFee(tournament.entry_fee ?? '0')
            setMaxPlayers(tournament.max_players || '')
            setMembershipRequired(tournament.membership_required ?? true)
            setPhotoGalleryUrl(tournament.photo_gallery_url || '')
            setDescription(tournament.description || '')
            setAccountant(tournament.accountant || '')
            setMapLocation(tournament.location || '')
            setLogoPreview(tournament.logo || '')
            setImageDtPreview(tournament.image_desktop || '')
            setImageMbPreview(tournament.image_mobile || '')
        }
    }, [tournament])

    // 3. Navigate on tournament save
    useEffect(() => {
        if (successCreate || successUpdate) {
            dispatch({ type: TOURNAMENT_CREATE_RESET })
            dispatch({ type: TOURNAMENT_UPDATE_RESET })
            navigate('/admin/tournaments')
        }
    }, [successCreate, successUpdate])

    // 5. Load holes when a round is selected in the contest modal
    useEffect(() => {
        if (selectedRound && showContestModal) {
            const day = days.find(d => d.id === Number(selectedRound))
            if (day?.course) dispatch(getCourseDetails(day.course))
        }
    }, [selectedRound, showContestModal])

    // 4. Close modal + re-fetch after round operations
    useEffect(() => {
        if (successDayCreate || successDayUpdate || successDayDelete
            || successAwardCreate || successAwardDelete
            || successContestCreate || successContestDelete
            || successAwardUpdate || successContestUpdate || successWinnerUpdate) {
            dispatch({ type: TOURNAMENT_DAY_CREATE_RESET })
            dispatch({ type: TOURNAMENT_DAY_UPDATE_RESET })
            dispatch({ type: TOURNAMENT_AWARD_CREATE_RESET })
            dispatch({ type: TOURNAMENT_CONTEST_CREATE_RESET })
            setShowDayModal(false)
            setShowAwardModal(false)
            setShowContestModal(false)
            if (id) dispatch(getTournamentDetails(id))
        }
    }, [successDayCreate, successDayUpdate, successDayDelete,
        successAwardCreate, successAwardDelete,
        successContestCreate, successContestDelete,
        successAwardUpdate, successContestUpdate, successWinnerUpdate])

    // 5. Reload registrations after add/update/delete
    useEffect(() => {
        if (successRegAdd || successRegUpdate || successRegDelete) {
            dispatch({ type: TOURNAMENT_REG_ADD_RESET })
            setShowRegModal(false)
            setRegUser('')
            setRegStatus('registered')
            if (id) dispatch(listTournamentRegistrations(id))
        }
    }, [successRegAdd, successRegUpdate, successRegDelete])

    // 6. (teams update handled optimistically in reducer via addTeamMember/removeTeamMember SUCCESS)

    // â”€â”€ Handlers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const submitHandler = (e) => {
        e.preventDefault()
        const fd = new FormData()
        fd.append('name', name)
        fd.append('type', type)
        fd.append('location', location)
        fd.append('status', tStatus)
        fd.append('teams', teams)
        fd.append('entry_fee', entryFee || '0')
        if (maxPlayers) fd.append('max_players', maxPlayers)
        fd.append('membership_required', membershipRequired)
        fd.append('photo_gallery_url', photoGalleryUrl)
        fd.append('description', description)
        if (accountant) fd.append('accountant', accountant)
        if (logoFile) fd.append('logo', logoFile)
        if (imageDtFile) fd.append('image_desktop', imageDtFile)
        if (imageMbFile) fd.append('image_mobile', imageMbFile)
        isEditing ? dispatch(updateTournament(id, fd)) : dispatch(createTournament(fd))
    }

    const openDayModal = (day = null) => {
        setEditingDay(day)
        if (day) {
            setDayCourse(day.course || '')
            setDayDate(day.day_date || '')
            setDayStartTime(day.start_time || '')
            setDayEndTime(day.end_time || '')
            setDayOrder(day.order || 1)
        } else {
            setDayCourse(courses.length > 0 ? courses[0].id : '')
            setDayDate('')
            setDayStartTime('')
            setDayEndTime('')
            setDayOrder((tournament?.days?.length || 0) + 1)
        }
        setShowDayModal(true)
    }

    const daySubmitHandler = (e) => {
        e.preventDefault()
        const payload = {
            course: dayCourse,
            day_date: dayDate,
            start_time: dayStartTime || null,
            end_time: dayEndTime || null,
            order: dayOrder,
        }
        if (editingDay) {
            dispatch(updateTournamentDay(editingDay.id, payload))
        } else {
            dispatch(createTournamentDay(id, payload))
        }
    }

    const deleteDayHandler = (dayId) => {
        if (window.confirm('Delete this round?')) {
            dispatch(deleteTournamentDay(dayId))
        }
    }

    const awardSubmitHandler = (e) => {
        e.preventDefault()
        dispatch(createTournamentAward(id, selectedAward))
    }

    const openContestModal = () => {
        const firstRound = days.length > 0 ? String(days[0].id) : ''
        setSelectedRound(firstRound)
        setSelectedContest('')
        setContestHole('')
        setContestPrize('')
        setShowContestModal(true)
    }

    const contestSubmitHandler = (e) => {
        e.preventDefault()
        dispatch(createTournamentContest(id, {
            contest: selectedContest,
            day: selectedRound || null,
            specific_hole: contestHole || null,
            prize_money: contestPrize,
        }))
    }

    const days       = tournament?.days     || []
    const awards_t   = tournament?.awards   || []
    const contests_t = tournament?.contests || []

    const filteredRegs = registrations.filter(r => {
        if (regFilter === 'all')        return true
        if (regFilter === 'pending')    return r.status === 'registered'
        if (regFilter === 'confirmed')  return r.status === 'confirmed'
        if (regFilter === 'unpaid')     return r.payment_status === 'pending'
        if (regFilter === 'paid')       return r.payment_status === 'paid'
        return true
    })

    // Teams tab computed
    const teamSizeMap = { 'Singles': 1, 'Doubles': 2, 'Quads': 4 }
    const teamSize = teamSizeMap[teams] || 2
    const activeRegistrations = registrations.filter(r => r.status !== 'cancelled')
    const assignedUserIds = new Set(tournTeams.flatMap(t => t.members.map(m => m.user)))
    const poolPlayers = activeRegistrations.filter(r => !assignedUserIds.has(r.user))
    const numTeams = activeRegistrations.length > 0 ? Math.ceil(activeRegistrations.length / teamSize) : 0
    const atMax = numTeams > 0 && tournTeams.length >= numTeams

    // Users not yet registered
    const registeredUserIds = registrations.map(r => r.user)
    const unregisteredUsers = users.filter(u => !registeredUserIds.includes(u.id))

    const addedAwardIds    = awards_t.map(a => a.award)
    const availableAwards  = awards.filter(a => !addedAwardIds.includes(a.id))

    // Contests already in the selected round â€” same type can't be added twice to same round
    const addedContestIdsForRound = contests_t
        .filter(tc => tc.day === Number(selectedRound))
        .map(tc => tc.contest)
    const availableContests = selectedRound
        ? contests.filter(c => !addedContestIdsForRound.includes(c.id))
        : contests

    // For the hole dropdown: holes from the course of the selected round
    const selectedDayObj = days.find(d => d.id === Number(selectedRound))
    const modalHoles = (selectedDayObj && modalCourse?.id === selectedDayObj.course)
        ? (modalCourse?.holes || [])
        : []

    return (
        <Container fluid='lg' className='pb-5'>
            <Form onSubmit={submitHandler}>

                {/* â”€â”€ Header: title | Cancel + Save â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
                <Row className='align-items-center mb-4'>
                    <Col>
                        <h2 className='mb-0'>{isEditing ? 'Edit Tournament' : 'Add Tournament'}</h2>
                    </Col>
                    <Col xs='auto' className='d-flex gap-2'>
                        <Button variant='outline-secondary' type='button' onClick={() => navigate('/admin/tournaments')}>
                            Cancel
                        </Button>
                        <Button type='submit' variant='dark' disabled={loadingCreate || loadingUpdate}>
                            {isEditing ? 'Save Changes' : 'Create Tournament'}
                        </Button>
                    </Col>
                </Row>

                {loadingDetails && <Loader />}
                {(errorDetails || errorCreate || errorUpdate) && (
                    <Message variant='danger'>{errorDetails || errorCreate || errorUpdate}</Message>
                )}

                {/* â”€â”€ Two-column: form fields (left) | images (right) â”€â”€ */}
                <Row className='gx-5'>

                    {/* â”€â”€ LEFT â€” form fields â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
                    <Col lg={8}>

                        {/* Name + Type */}
                        <Row className='mb-3'>
                            <Col md={8}>
                                <Form.Group>
                                    <Form.Label>Tournament Name</Form.Label>
                                    <Form.Control
                                        type='text'
                                        placeholder='e.g. BNB 2025 Fall Classic'
                                        value={name}
                                        onChange={e => setName(e.target.value)}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Type</Form.Label>
                                    <Form.Select value={type} onChange={e => setType(e.target.value)}>
                                        <option value='BNB'>BNB</option>
                                        <option value='Other'>Other</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Status + Teams + Entry Fee + Max Players */}
                        <Row className='mb-3'>
                            <Col sm={3}>
                                <Form.Group>
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select value={tStatus} onChange={e => setTStatus(e.target.value)}>
                                        <option value='draft'>Draft</option>
                                        <option value='upcoming'>Upcoming</option>
                                        <option value='active'>Active</option>
                                        <option value='completed'>Completed</option>
                                        <option value='cancelled'>Cancelled</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col sm={3}>
                                <Form.Group>
                                    <Form.Label>Teams Format</Form.Label>
                                    <Form.Select value={teams} onChange={e => setTeams(e.target.value)}>
                                        <option value='Singles'>Singles</option>
                                        <option value='Doubles'>Doubles</option>
                                        <option value='Quads'>Quads</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col sm={3}>
                                <Form.Group>
                                    <Form.Label>Entry Fee ($)</Form.Label>
                                    <Form.Control
                                        type='number' min='0' step='0.01'
                                        value={entryFee}
                                        onChange={e => setEntryFee(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={3}>
                                <Form.Group>
                                    <Form.Label>Max Players</Form.Label>
                                    <Form.Control
                                        type='number' min='1'
                                        value={maxPlayers}
                                        onChange={e => setMaxPlayers(e.target.value)}
                                        placeholder='Unlimited'
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Location + Google Maps */}
                        <Form.Group className='mb-2'>
                            <Form.Label>Location / City</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder='e.g. Las Vegas, NV'
                                value={location}
                                onChange={e => setLocation(e.target.value)}
                                onBlur={e => setMapLocation(e.target.value)}
                            />
                            <Form.Text className='text-muted'>Map updates when you leave the field</Form.Text>
                        </Form.Group>

                        {mapLocation && (
                            <div className='mb-4 rounded overflow-hidden border'>
                                <iframe
                                    title='tournament-map'
                                    width='100%'
                                    height='200'
                                    style={{ border: 0, display: 'block' }}
                                    src={`https://maps.google.com/maps?q=${encodeURIComponent(mapLocation)}&output=embed`}
                                    allowFullScreen
                                    loading='lazy'
                                />
                            </div>
                        )}

                        {/* Gallery URL + Membership */}
                        <Row className='mb-3'>
                            <Col md={8}>
                                <Form.Group>
                                    <Form.Label>Photo Gallery URL <span className='text-muted'>(optional)</span></Form.Label>
                                    <Form.Control
                                        type='text' placeholder='https://...'
                                        value={photoGalleryUrl}
                                        onChange={e => setPhotoGalleryUrl(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4} className='d-flex align-items-end pb-2'>
                                <Form.Check
                                    type='checkbox'
                                    label='Membership Required'
                                    checked={membershipRequired}
                                    onChange={e => setMembershipRequired(e.target.checked)}
                                />
                            </Col>
                        </Row>

                        {/* HTML Description */}
                        <Form.Group className='mb-2'>
                            <div className='d-flex justify-content-between align-items-center mb-1'>
                                <Form.Label className='mb-0'>Description</Form.Label>
                                <Button
                                    variant={descPreview ? 'outline-secondary' : 'outline-primary'}
                                    size='sm' type='button'
                                    onClick={() => setDescPreview(p => !p)}
                                >
                                    {descPreview
                                        ? <><i className='fa-solid fa-code me-1'></i>Edit HTML</>
                                        : <><i className='fa-solid fa-eye me-1'></i>Preview</>
                                    }
                                </Button>
                            </div>
                            {descPreview ? (
                                <div
                                    className='border rounded p-3'
                                    style={{ minHeight: '120px', background: '#fff' }}
                                    dangerouslySetInnerHTML={{ __html: description || '<p class="text-muted">Nothing to preview yet.</p>' }}
                                />
                            ) : (
                                <Form.Control
                                    as='textarea' rows={5}
                                    placeholder='<p>Enter HTML description...</p>'
                                    value={description}
                                    onChange={e => setDescription(e.target.value)}
                                    style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}
                                />
                            )}
                        </Form.Group>

                    </Col>{/* end LEFT */}

                    {/* â”€â”€ RIGHT â€” image uploads â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
                    <Col lg={4} className='mt-4 mt-lg-0'>
                        <div className='h-100 border-start ps-4'>
                            <h5 className='mb-3'>
                                <i className='fa-solid fa-image me-2 text-secondary'></i>Images
                            </h5>

                            {/* Logo */}
                            <Form.Group className='mb-4'>
                                <Form.Label className='fw-semibold'>Logo</Form.Label>
                                {logoPreview && (
                                    <div className='mb-2 text-center'>
                                        <img src={logoPreview} alt='logo' className='img-thumbnail'
                                            style={{ maxHeight: '80px', objectFit: 'contain' }} />
                                    </div>
                                )}
                                <Form.Control type='file' accept='image/*' size='sm'
                                    onChange={e => {
                                        const f = e.target.files[0]
                                        if (f) { setLogoFile(f); setLogoPreview(URL.createObjectURL(f)) }
                                    }} />
                            </Form.Group>

                            {/* Main (Desktop) Image */}
                            <Form.Group className='mb-4'>
                                <Form.Label className='fw-semibold'>Main Image</Form.Label>
                                {imageDtPreview && (
                                    <div className='mb-2'>
                                        <img src={imageDtPreview} alt='main' className='img-thumbnail w-100'
                                            style={{ maxHeight: '130px', objectFit: 'cover' }} />
                                    </div>
                                )}
                                <Form.Control type='file' accept='image/*' size='sm'
                                    onChange={e => {
                                        const f = e.target.files[0]
                                        if (f) { setImageDtFile(f); setImageDtPreview(URL.createObjectURL(f)) }
                                    }} />
                            </Form.Group>

                            {/* Mobile Image */}
                            <Form.Group className='mb-4'>
                                <Form.Label className='fw-semibold'>Mobile Image</Form.Label>
                                {imageMbPreview && (
                                    <div className='mb-2'>
                                        <img src={imageMbPreview} alt='mobile' className='img-thumbnail w-100'
                                            style={{ maxHeight: '130px', objectFit: 'cover' }} />
                                    </div>
                                )}
                                <Form.Control type='file' accept='image/*' size='sm'
                                    onChange={e => {
                                        const f = e.target.files[0]
                                        if (f) { setImageMbFile(f); setImageMbPreview(URL.createObjectURL(f)) }
                                    }} />
                            </Form.Group>
                        </div>
                    </Col>{/* end RIGHT */}

                </Row>{/* end two-column Row */}

                {/* â”€â”€ Tabs â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
                <hr className='my-4' />
                {isEditing ? (
                    <Tab.Container activeKey={activeTab} onSelect={k => setActiveTab(k)}>
                        <Nav variant='tabs' className='mb-3'>
                            <Nav.Item>
                                <Nav.Link eventKey='jobs'>
                                    <i className='fa-solid fa-briefcase me-1'></i>Jobs
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey='rounds'>
                                    Rounds <Badge bg='secondary' pill>{days.length}</Badge>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey='awards'>
                                    <i className='fa-solid fa-trophy me-1'></i>
                                    Awards <Badge bg='secondary' pill>{awards_t.length}</Badge>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey='contests'>
                                    <i className='fa-solid fa-flag me-1'></i>
                                    Contests <Badge bg='secondary' pill>{contests_t.length}</Badge>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey='winners'>
                                    <i className='fa-solid fa-medal me-1'></i>Winners
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey='players'>
                                    <i className='fa-solid fa-users me-1'></i>
                                    Players <Badge bg='secondary' pill>{registrations.length}</Badge>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey='teams'>
                                    <i className='fa-solid fa-people-group me-1'></i>
                                    Teams <Badge bg='secondary' pill>{tournTeams.length}</Badge>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>

                        <Tab.Content>

                            {/* â”€â”€ Jobs tab â”€â”€ */}
                            <Tab.Pane eventKey='jobs'>
                                <Row className='mt-3'>
                                    <Col sm={6} md={4}>
                                        <Form.Group>
                                            <Form.Label>Accountant</Form.Label>
                                            <Form.Select value={accountant} onChange={e => setAccountant(e.target.value)}>
                                                <option value=''>-- Unassigned --</option>
                                                {users.map(u => (
                                                    <option key={u.id} value={u.id}>
                                                        {u.name || u.username}{u.email ? ` (${u.email})` : ''}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Text className='text-muted'>Saved with the Save Changes button above.</Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab.Pane>

                            {/* â”€â”€ Rounds tab â”€â”€ */}
                            <Tab.Pane eventKey='rounds'>
                                <div className='d-flex justify-content-between align-items-center mt-3 mb-3'>
                                    <h5 className='mb-0'>Rounds</h5>
                                    <Button variant='dark' size='sm' type='button' onClick={() => openDayModal()}>
                                        <i className='fa-solid fa-plus me-1'></i> Add Round
                                    </Button>
                                </div>
                                {(errorDayCreate || errorDayUpdate || errorDayDelete) && (
                                    <Message variant='danger'>{errorDayCreate || errorDayUpdate || errorDayDelete}</Message>
                                )}
                                {days.length === 0 ? (
                                    <p className='text-muted'>No rounds yet.</p>
                                ) : (
                                    <Row xs={1} sm={2} md={3} className='g-3 mb-4'>
                                        {days.map(day => (
                                            <Col key={day.id}>
                                                <Card className='h-100 shadow-sm'>
                                                    <Card.Body>
                                                        <div className='d-flex justify-content-between align-items-start mb-1'>
                                                            <Badge bg='secondary'>Round {day.order}</Badge>
                                                            <small className='text-muted'>{day.day_date}</small>
                                                        </div>
                                                        <Card.Title className='fs-6 fw-bold mb-1'>{day.course_name}</Card.Title>
                                                        <p className='text-muted small mb-3'>
                                                            {day.start_time || 'â€“'} &rarr; {day.end_time || 'â€“'}
                                                        </p>
                                                        <div className='d-flex gap-2'>
                                                            <Button variant='outline-secondary' size='sm' type='button' onClick={() => openDayModal(day)}>
                                                                <i className='fa-solid fa-pen'></i>
                                                            </Button>
                                                            <Button variant='outline-danger' size='sm' type='button' onClick={() => deleteDayHandler(day.id)}>
                                                                <i className='fa-solid fa-trash'></i>
                                                            </Button>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                )}
                            </Tab.Pane>

                            {/* â”€â”€ Awards tab â”€â”€ */}
                            <Tab.Pane eventKey='awards'>
                                <div className='d-flex justify-content-between align-items-center mt-3 mb-3'>
                                    <h5 className='mb-0'>Awards</h5>
                                    <Button
                                        variant='dark' size='sm' type='button'
                                        onClick={() => {
                                            setSelectedAward(availableAwards.length > 0 ? availableAwards[0].id : '')
                                            setShowAwardModal(true)
                                        }}
                                        disabled={availableAwards.length === 0}
                                    >
                                        <i className='fa-solid fa-plus me-1'></i> Add Award
                                    </Button>
                                </div>
                                {(errorAwardCreate || errorAwardDelete) && (
                                    <Message variant='danger'>{errorAwardCreate || errorAwardDelete}</Message>
                                )}
                                {awards_t.length === 0 ? (
                                    <p className='text-muted'>No awards added yet.</p>
                                ) : (
                                    <Row xs={1} sm={2} md={3} className='g-3 mb-4'>
                                        {awards_t.map(ta => (
                                            <Col key={ta.id}>
                                                <Card className='h-100 shadow-sm'>
                                                    <Card.Body>
                                                        <Card.Title className='fs-6 fw-bold mb-1'>
                                                            <i className='fa-solid fa-trophy me-2 text-warning'></i>
                                                            {ta.award_name}
                                                        </Card.Title>
                                                        {ta.award_description && (
                                                            <p className='text-muted small mb-3'>{ta.award_description}</p>
                                                        )}
                                                        <Button variant='outline-danger' size='sm' type='button'
                                                            onClick={() => {
                                                                if (window.confirm('Remove this award?'))
                                                                    dispatch(deleteTournamentAward(ta.id))
                                                            }}>
                                                            <i className='fa-solid fa-trash me-1'></i> Remove
                                                        </Button>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                )}
                            </Tab.Pane>

                            {/* â”€â”€ Contests tab â”€â”€ */}
                            <Tab.Pane eventKey='contests'>
                                <div className='d-flex justify-content-between align-items-center mt-3 mb-3'>
                                    <h5 className='mb-0'>Contests</h5>
                                    <Button
                                        variant='dark' size='sm' type='button'
                                        onClick={openContestModal}
                                        disabled={days.length === 0}
                                    >
                                        <i className='fa-solid fa-plus me-1'></i> Add Contest
                                    </Button>
                                </div>
                                {(errorContestCreate || errorContestDelete) && (
                                    <Message variant='danger'>{errorContestCreate || errorContestDelete}</Message>
                                )}
                                {contests_t.length === 0 ? (
                                    <p className='text-muted'>
                                        {days.length === 0 ? 'Add rounds first before adding contests.' : 'No contests added yet.'}
                                    </p>
                                ) : (
                                    <Row xs={1} sm={2} md={3} className='g-3 mb-4'>
                                        {contests_t.map(tc => (
                                            <Col key={tc.id}>
                                                <Card className='h-100 shadow-sm'>
                                                    <Card.Body>
                                                        <div className='d-flex justify-content-between align-items-start mb-1'>
                                                            <Card.Title className='fs-6 fw-bold mb-0'>
                                                                <i className='fa-solid fa-flag me-2 text-success'></i>
                                                                {tc.contest_name}
                                                            </Card.Title>
                                                            {tc.day_order && (
                                                                <Badge bg='secondary' className='ms-2 flex-shrink-0'>Round {tc.day_order}</Badge>
                                                            )}
                                                        </div>
                                                        {tc.contest_description && (
                                                            <p className='text-muted small mb-2'>{tc.contest_description}</p>
                                                        )}
                                                        <div className='d-flex gap-3 small text-muted mb-3'>
                                                            {tc.specific_hole && (
                                                                <span><i className='fa-solid fa-flag-checkered me-1'></i>Hole {tc.specific_hole}</span>
                                                            )}
                                                            {tc.prize_money && (
                                                                <span><i className='fa-solid fa-dollar-sign me-1'></i>{tc.prize_money}</span>
                                                            )}
                                                        </div>
                                                        <Button variant='outline-danger' size='sm' type='button'
                                                            onClick={() => {
                                                                if (window.confirm('Remove this contest?'))
                                                                    dispatch(deleteTournamentContest(tc.id))
                                                            }}>
                                                            <i className='fa-solid fa-trash me-1'></i> Remove
                                                        </Button>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                )}
                            </Tab.Pane>

                            {/* ── Winners tab ── */}
                            <Tab.Pane eventKey='winners'>
                                <div className='mt-3'>


                                    {/* Overall Tournament Winner */}
                                    <h5 className='mb-3'>
                                        <i className='fa-solid fa-crown me-2 text-warning'></i>Overall Tournament Winner
                                    </h5>
                                    {tournTeams.length === 0 ? (
                                        <p className='text-muted small mb-4'>No teams yet. Add teams in the Teams tab first.</p>
                                    ) : (
                                        <div className='mb-2' style={{ maxWidth: '480px' }}>
                                            {tournament?.winner_team_name && (
                                                <Badge bg='success' className='mb-2 d-block text-start fs-6 px-3 py-2'>
                                                    <i className='fa-solid fa-crown me-2'></i>{tournament.winner_team_name}
                                                </Badge>
                                            )}
                                            <Form.Select
                                                value={tournament?.winner_team_id ?? ''}
                                                onChange={e => dispatch(updateTournamentWinner(id, e.target.value || null))}>
                                                <option value=''>-- No Winner --</option>
                                                {tournTeams.map(t => {
                                                    const playerNames = t.members.map(m => m.player_name).join(', ')
                                                    return (
                                                        <option key={t.id} value={t.id}>
                                                            {t.name}{playerNames ? ` \u2014 ${playerNames}` : ''}
                                                        </option>
                                                    )
                                                })}
                                            </Form.Select>
                                        </div>
                                    )}

                                    <hr className='mb-4' />

                                    {/* Awards */}
                                    <h5 className='mb-3'>
                                        <i className='fa-solid fa-trophy me-2 text-warning'></i>Awards
                                    </h5>
                                    {awards_t.length === 0 ? (
                                        <p className='text-muted small mb-4'>No awards added to this tournament yet.</p>
                                    ) : (
                                        <Row xs={1} sm={2} md={3} className='g-3 mb-4'>
                                            {awards_t.map(ta => (
                                                <Col key={ta.id}>
                                                    <Card className='h-100 shadow-sm'>
                                                        <Card.Body>
                                                            <div className='fw-bold mb-1'>
                                                                <i className='fa-solid fa-award me-2 text-warning'></i>
                                                                {ta.award_name}
                                                            </div>
                                                            {ta.award_description && (
                                                                <p className='text-muted small mb-2'>{ta.award_description}</p>
                                                            )}
                                                            {ta.winner_name && (
                                                                <Badge bg='success' className='mb-2'>
                                                                    <i className='fa-solid fa-check me-1'></i>{ta.winner_name}
                                                                </Badge>
                                                            )}
                                                            <Form.Select size='sm'
                                                                value={ta.winner ?? ''}
                                                                onChange={e => dispatch(updateTournamentAward(ta.id, e.target.value || null))}>
                                                                <option value=''>-- No Winner --</option>
                                                                {registrations.filter(r => r.status !== 'cancelled').map(r => (
                                                                    <option key={r.user} value={r.user}>{r.player_name}</option>
                                                                ))}
                                                            </Form.Select>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            ))}
                                        </Row>
                                    )}

                                    <hr />

                                    {/* Contests */}
                                    <h5 className='mb-3 mt-3'>
                                        <i className='fa-solid fa-flag me-2 text-success'></i>Contests
                                    </h5>
                                    {contests_t.length === 0 ? (
                                        <p className='text-muted small'>No contests added to this tournament yet.</p>
                                    ) : (
                                        <Row xs={1} sm={2} md={3} className='g-3'>
                                            {contests_t.map(tc => (
                                                <Col key={tc.id}>
                                                    <Card className='h-100 shadow-sm'>
                                                        <Card.Body>
                                                            <div className='fw-bold mb-1'>
                                                                <i className='fa-solid fa-flag me-2 text-success'></i>
                                                                {tc.contest_name}
                                                            </div>
                                                            <div className='d-flex flex-wrap gap-2 mb-2'>
                                                                {tc.day_order && (
                                                                    <Badge bg='secondary'>Round {tc.day_order}</Badge>
                                                                )}
                                                                {tc.specific_hole && (
                                                                    <Badge bg='light' text='dark'>Hole {tc.specific_hole}</Badge>
                                                                )}
                                                                {tc.prize_money && (
                                                                    <Badge bg='light' text='dark'>${tc.prize_money}</Badge>
                                                                )}
                                                            </div>
                                                            {tc.winner_name && (
                                                                <Badge bg='success' className='mb-2'>
                                                                    <i className='fa-solid fa-check me-1'></i>{tc.winner_name}
                                                                    {tc.result_yards ? <span className='ms-1'>· {tc.result_yards}</span> : ''}
                                                                </Badge>
                                                            )}
                                                            <Form.Select size='sm'
                                                                value={tc.winner ?? ''}
                                                                onChange={e => dispatch(updateTournamentContest(tc.id, e.target.value || null, tc.result_yards))}>
                                                                <option value=''>-- No Winner --</option>
                                                                {registrations.filter(r => r.status !== 'cancelled').map(r => (
                                                                    <option key={r.user} value={r.user}>{r.player_name}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control
                                                                key={`yards-${tc.id}-${tc.result_yards}`}
                                                                size='sm' type='text' placeholder='e.g. 285 YDS, 10 FT, 6 IN'
                                                                className='mt-2'
                                                                defaultValue={tc.result_yards ?? ''}
                                                                onBlur={e => {
                                                                    const val = e.target.value.trim() || null
                                                                    dispatch(updateTournamentContest(tc.id, tc.winner ?? null, val))
                                                                }}
                                                            />
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            ))}
                                        </Row>
                                    )}
                                </div>
                            </Tab.Pane>
                            {/* ── Players tab ── */}
                            <Tab.Pane eventKey='players'>
                                <div className='d-flex justify-content-between align-items-center mt-3 mb-3'>
                                    <h5 className='mb-0'>Players</h5>
                                    <Button variant='dark' size='sm' type='button'
                                        onClick={() => { setRegUser(unregisteredUsers[0]?.id || ''); setShowRegModal(true) }}
                                        disabled={unregisteredUsers.length === 0}
                                    >
                                        <i className='fa-solid fa-user-plus me-1'></i> Add Player
                                    </Button>
                                </div>

                                {/* Filter pills */}
                                <div className='d-flex flex-wrap gap-2 mb-3'>
                                    {[
                                        { key: 'all',       label: 'All',       count: registrations.length },
                                        { key: 'pending',   label: 'Pending',   count: registrations.filter(r => r.status === 'registered').length },
                                        { key: 'confirmed', label: 'Confirmed', count: registrations.filter(r => r.status === 'confirmed').length },
                                        { key: 'unpaid',    label: 'Unpaid',    count: registrations.filter(r => r.payment_status === 'pending').length },
                                        { key: 'paid',      label: 'Paid',      count: registrations.filter(r => r.payment_status === 'paid').length },
                                    ].map(f => (
                                        <Button key={f.key} size='sm' type='button'
                                            variant={regFilter === f.key ? 'dark' : 'outline-secondary'}
                                            onClick={() => setRegFilter(f.key)}
                                        >
                                            {f.label} <Badge bg={regFilter === f.key ? 'light' : 'secondary'}
                                                text={regFilter === f.key ? 'dark' : undefined} pill>{f.count}</Badge>
                                        </Button>
                                    ))}
                                </div>

                                {(errorRegList || errorRegAdd) && (
                                    <Message variant='danger'>{errorRegList || errorRegAdd}</Message>
                                )}
                                {loadingRegList ? <Loader /> : filteredRegs.length === 0 ? (
                                    <p className='text-muted'>No players match this filter.</p>
                                ) : (
                                    <div className='table-responsive'>
                                        <table className='table table-hover align-middle mb-0'>
                                            <thead className='table-light'>
                                                <tr>
                                                    <th>Player</th>
                                                    <th>Email</th>
                                                    <th>Joined</th>
                                                    <th>Status</th>
                                                    <th>Payment</th>
                                                    <th>Paid $</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredRegs.map(reg => (
                                                    <tr key={reg.id}>
                                                        <td className='fw-semibold'>{reg.player_name}</td>
                                                        <td className='text-muted small'>{reg.player_email}</td>
                                                        <td className='text-muted small'>
                                                            {new Date(reg.registered_at).toLocaleDateString()}
                                                        </td>
                                                        <td>
                                                            <Form.Select size='sm' style={{ minWidth: '120px' }}
                                                                value={reg.status}
                                                                onChange={e => dispatch(updateTournamentRegistration(reg.id, { status: e.target.value }))}
                                                            >
                                                                <option value='registered'>Registered</option>
                                                                <option value='confirmed'>Confirmed</option>
                                                                <option value='cancelled'>Cancelled</option>
                                                            </Form.Select>
                                                        </td>
                                                        <td>
                                                            <Form.Select size='sm' style={{ minWidth: '110px' }}
                                                                value={reg.payment_status}
                                                                onChange={e => dispatch(updateTournamentRegistration(reg.id, { payment_status: e.target.value }))}
                                                            >
                                                                <option value='pending'>Pending</option>
                                                                <option value='paid'>Paid</option>
                                                                <option value='refunded'>Refunded</option>
                                                            </Form.Select>
                                                        </td>
                                                        <td>
                                                            <Form.Control size='sm' type='number' min='0' step='0.01'
                                                                style={{ width: '90px' }}
                                                                defaultValue={reg.amount_paid || ''}
                                                                onBlur={e => {
                                                                    const val = e.target.value
                                                                    if (val !== String(reg.amount_paid || ''))
                                                                        dispatch(updateTournamentRegistration(reg.id, { amount_paid: val || null }))
                                                                }}
                                                                placeholder='0.00'
                                                            />
                                                        </td>
                                                        <td>
                                                            <Button variant='outline-danger' size='sm' type='button'
                                                                onClick={() => {
                                                                    if (window.confirm(`Remove ${reg.player_name} from this tournament?`))
                                                                        dispatch(deleteTournamentRegistration(reg.id))
                                                                }}
                                                            >
                                                                <i className='fa-solid fa-trash'></i>
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </Tab.Pane>

                            {/* ── Teams tab ── */}
                            <Tab.Pane eventKey='teams'>
                                {/* Header + controls */}
                                <div className='d-flex justify-content-between align-items-start mt-3 mb-1 flex-wrap gap-2'>
                                    <div>
                                        <h5 className='mb-0'>Teams</h5>
                                        <small className='text-muted'>
                                            {teams} format &mdash; {teamSize} per team &mdash;&nbsp;
                                            {activeRegistrations.length} active players
                                        </small>
                                    </div>
                                    <div className='d-flex gap-2 align-items-center flex-wrap'>
                                        <OverlayTrigger placement='top'
                                            overlay={
                                                <Tooltip>
                                                    {atMax
                                                        ? `Max reached — ${numTeams} teams for ${activeRegistrations.length} players`
                                                        : `${tournTeams.length} of ${numTeams} teams`}
                                                </Tooltip>
                                            }>
                                            <span>
                                                <Button variant='dark' size='sm' type='button'
                                                    disabled={atMax || !id || loadingTeamAdd}
                                                    style={atMax ? { pointerEvents: 'none' } : {}}
                                                    onClick={() => dispatch(addTournamentTeam(id))}>
                                                    <i className='fa-solid fa-plus me-1'></i> Add Team
                                                </Button>
                                            </span>
                                        </OverlayTrigger>
                                        <Button variant='outline-danger' size='sm' type='button'
                                            disabled={tournTeams.length === 0}
                                            onClick={async () => { if (window.confirm('Clear all teams?')) { await dispatch(clearTournamentTeams(id)); dispatch(listTournamentTeams(id)) } }}>
                                            <i className='fa-solid fa-trash me-1'></i> Clear All
                                        </Button>
                                    </div>
                                </div>
                                <hr className='mt-2 mb-3' />

                                {loadingTeams ? <Loader /> : (
                                    <Row className='g-4'>
                                        {/* Player pool (left) */}
                                        <Col md={4}>
                                            <h6 className='text-muted text-uppercase small mb-2'>
                                                <i className='fa-solid fa-circle-user me-1'></i>Available Players
                                            </h6>
                                            <div className='border rounded p-2'
                                                style={{ minHeight: '200px', background: dragOverTeamId === 'pool' ? '#f0f9ff' : '#f8f9fa' }}
                                                onDragOver={e => { e.preventDefault(); setDragOverTeamId('pool') }}
                                                onDragLeave={() => setDragOverTeamId(null)}
                                                onDrop={e => {
                                                    e.preventDefault(); setDragOverTeamId(null)
                                                    if (dragFromMemberId) {
                                                        dispatch(removeTeamMember(dragFromMemberId))
                                                    }
                                                    setDragPlayerId(null); setDragFromMemberId(null)
                                                }}>
                                                {poolPlayers.length === 0
                                                    ? <p className='text-muted small text-center mt-4'>All players assigned</p>
                                                    : poolPlayers.map(reg => (
                                                        <div key={reg.id} draggable
                                                            onDragStart={() => { setDragPlayerId(reg.user); setDragFromMemberId(null) }}
                                                            onDragEnd={() => { setDragPlayerId(null); setDragFromMemberId(null) }}
                                                            className='d-flex justify-content-between align-items-center border rounded p-2 mb-2 bg-white'
                                                            style={{ cursor: 'grab', opacity: dragPlayerId === reg.user ? 0.4 : 1 }}>
                                                            <div>
                                                                <div className='fw-semibold small'>{reg.player_name}</div>
                                                                <div className='text-muted' style={{ fontSize: '0.75rem' }}>
                                                                    {reg.handicap != null ? `Hdcp: ${reg.handicap}` : 'No hdcp'}
                                                                </div>
                                                            </div>
                                                            <i className='fa-solid fa-grip-vertical text-muted'></i>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </Col>

                                        {/* Teams grid (right) */}
                                        <Col md={8}>
                                            <h6 className='text-muted text-uppercase small mb-2'>
                                                <i className='fa-solid fa-flag me-1'></i>Teams
                                            </h6>
                                            {tournTeams.length === 0 ? (
                                                <p className='text-muted'>No teams yet. Click <strong>Add Team</strong> to create teams one at a time.</p>
                                            ) : (
                                                <Row xs={1} sm={2} className='g-3'>
                                                    {tournTeams.map(team => {
                                                        const isFull = team.members.length >= team.size
                                                        const isOver = dragOverTeamId === team.id
                                                        return (
                                                            <Col key={team.id}>
                                                                <Card className={`h-100 shadow-sm ${isOver && !isFull ? 'border-primary' : ''}`}
                                                                    style={{ background: isOver && !isFull ? '#f0f4ff' : undefined }}
                                                                    onDragOver={e => { e.preventDefault(); if (!isFull) setDragOverTeamId(team.id) }}
                                                                    onDragLeave={() => setDragOverTeamId(null)}
                                                                    onDrop={e => {
                                                                        e.preventDefault(); setDragOverTeamId(null)
                                                                        if (dragPlayerId && !isFull)
                                                                            dispatch(addTeamMember(team.id, dragPlayerId))
                                                                        setDragPlayerId(null); setDragFromMemberId(null)
                                                                    }}>
                                                                    <Card.Body>
                                                                        <div className='d-flex justify-content-between align-items-center mb-2'>
                                                                            <span className='fw-bold small'>{team.name}</span>
                                                                            {isFull && team.avg_handicap != null && (
                                                                                <Badge bg='info' text='dark'>Avg {team.avg_handicap}</Badge>
                                                                            )}
                                                                        </div>
                                                                        {Array.from({ length: team.size }).map((_, i) => {
                                                                            const member = team.members[i]
                                                                            return member ? (
                                                                                <div key={member.id} draggable
                                                                                    onDragStart={() => { setDragPlayerId(member.user); setDragFromMemberId(member.id) }}
                                                                                    onDragEnd={() => { setDragPlayerId(null); setDragFromMemberId(null) }}
                                                                                    className='d-flex justify-content-between align-items-center border rounded p-2 mb-1 bg-white'
                                                                                    style={{ cursor: 'grab', fontSize: '0.85rem', opacity: dragFromMemberId === member.id ? 0.4 : 1 }}>
                                                                                    <div>
                                                                                        <div className='fw-semibold'>{member.player_name}</div>
                                                                                        <div className='text-muted' style={{ fontSize: '0.75rem' }}>
                                                                                            {member.handicap != null ? `Hdcp: ${member.handicap}` : '–'}
                                                                                        </div>
                                                                                    </div>
                                                                                    <Button variant='link' size='sm' type='button'
                                                                                        className='text-danger p-0'
                                                                                        onClick={() => dispatch(removeTeamMember(member.id))}>
                                                                                        <i className='fa-solid fa-xmark'></i>
                                                                                    </Button>
                                                                                </div>
                                                                            ) : (
                                                                                <div key={`empty-${i}`}
                                                                                    className='border rounded p-2 mb-1 text-center text-muted'
                                                                                    style={{ fontSize: '0.8rem', borderStyle: 'dashed', background: isOver ? '#e8f0fe' : '#fafafa' }}>
                                                                                    Drop player here
                                                                                </div>
                                                                            )
                                                                        })}
                                                                    </Card.Body>
                                                                </Card>
                                                            </Col>
                                                        )
                                                    })}
                                                </Row>
                                            )}
                                        </Col>
                                    </Row>
                                )}
                            </Tab.Pane>

                        </Tab.Content>
                    </Tab.Container>
                ) : (
                    <p className='text-muted'>
                        <small>Save the tournament first to manage jobs, rounds, awards, and contests.</small>
                    </p>
                )}

            </Form>

            {/* â”€â”€ Round Modal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
            <Modal show={showDayModal} onHide={() => setShowDayModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{editingDay ? `Edit Round ${editingDay.order}` : 'Add Round'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(loadingDayCreate || loadingDayUpdate) && <Loader />}
                    <Form id='day-form' onSubmit={daySubmitHandler}>
                        <Form.Group className='mb-3'>
                            <Form.Label>Course</Form.Label>
                            <Form.Select value={dayCourse} onChange={e => setDayCourse(e.target.value)} required>
                                <option value=''>-- Select Course --</option>
                                {courses.map(c => (
                                    <option key={c.id} value={c.id}>
                                        {c.name}{c.location ? ` â€” ${c.location}` : ''}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Row className='mb-3'>
                            <Col sm={8}>
                                <Form.Group>
                                    <Form.Label>Date</Form.Label>
                                    <Form.Control type='date' value={dayDate} onChange={e => setDayDate(e.target.value)} required />
                                </Form.Group>
                            </Col>
                            <Col sm={4}>
                                <Form.Group>
                                    <Form.Label>Round #</Form.Label>
                                    <Form.Control type='number' min='1' value={dayOrder} onChange={e => setDayOrder(e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Start Time <span className='text-muted'>(optional)</span></Form.Label>
                                    <Form.Control type='time' value={dayStartTime} onChange={e => setDayStartTime(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>End Time <span className='text-muted'>(optional)</span></Form.Label>
                                    <Form.Control type='time' value={dayEndTime} onChange={e => setDayEndTime(e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={() => setShowDayModal(false)}>Cancel</Button>
                    <Button variant='dark' type='submit' form='day-form'>
                        {editingDay ? 'Save Round' : 'Add Round'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* â”€â”€ Award Modal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
            <Modal show={showAwardModal} onHide={() => setShowAwardModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Award</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingAwardCreate && <Loader />}
                    <Form id='award-form' onSubmit={awardSubmitHandler}>
                        <Form.Group>
                            <Form.Label>Award</Form.Label>
                            <Form.Select value={selectedAward} onChange={e => setSelectedAward(e.target.value)} required>
                                <option value=''>-- Select Award --</option>
                                {availableAwards.map(a => (
                                    <option key={a.id} value={a.id}>{a.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={() => setShowAwardModal(false)}>Cancel</Button>
                    <Button variant='dark' type='submit' form='award-form'>Add Award</Button>
                </Modal.Footer>
            </Modal>

            {/* â”€â”€ Contest Modal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
            <Modal show={showContestModal} onHide={() => setShowContestModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Contest</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingContestCreate && <Loader />}
                    <Form id='contest-form' onSubmit={contestSubmitHandler}>

                        <Form.Group className='mb-3'>
                            <Form.Label>Round</Form.Label>
                            <Form.Select
                                value={selectedRound}
                                onChange={e => { setSelectedRound(e.target.value); setContestHole('') }}
                                required
                            >
                                <option value=''>-- Select Round --</option>
                                {days.map(d => (
                                    <option key={d.id} value={d.id}>
                                        Round {d.order} â€” {d.course_name} ({d.day_date})
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className='mb-3'>
                            <Form.Label>Contest</Form.Label>
                            <Form.Select value={selectedContest} onChange={e => setSelectedContest(e.target.value)} required>
                                <option value=''>-- Select Contest --</option>
                                {availableContests.map(c => (
                                    <option key={c.id} value={c.id}>{c.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Row>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Hole <span className='text-muted'>(optional)</span></Form.Label>
                                    {modalHoles.length > 0 ? (
                                        <Form.Select value={contestHole} onChange={e => setContestHole(e.target.value)}>
                                            <option value=''>-- Any hole --</option>
                                            {modalHoles.map(h => (
                                                <option key={h.id} value={h.number}>
                                                    Hole {h.number} â€” Par {h.par}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    ) : (
                                        <Form.Control
                                            type='number' min='1' max='18'
                                            value={contestHole}
                                            onChange={e => setContestHole(e.target.value)}
                                            placeholder={selectedRound ? 'Loadingâ€¦' : 'Select round first'}
                                            disabled={!selectedRound}
                                        />
                                    )}
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Prize <span className='text-muted'>(optional)</span></Form.Label>
                                    <Form.Control
                                        type='text' value={contestPrize}
                                        onChange={e => setContestPrize(e.target.value)}
                                        placeholder='e.g. $500'
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={() => setShowContestModal(false)}>Cancel</Button>
                    <Button variant='dark' type='submit' form='contest-form'>Add Contest</Button>
                </Modal.Footer>
            </Modal>

            {/* ── Add Player Modal ──────────────────────────────── */}
            <Modal show={showRegModal} onHide={() => setShowRegModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Player</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingRegAdd && <Loader />}
                    {errorRegAdd && <Message variant='danger'>{errorRegAdd}</Message>}
                    <Form id='reg-form' onSubmit={e => {
                        e.preventDefault()
                        dispatch(addTournamentRegistration(id, { user: regUser, status: regStatus }))
                    }}>
                        <Form.Group className='mb-3'>
                            <Form.Label>Player</Form.Label>
                            <Form.Select value={regUser} onChange={e => setRegUser(e.target.value)} required>
                                <option value=''>-- Select Player --</option>
                                {unregisteredUsers.map(u => (
                                    <option key={u.id} value={u.id}>
                                        {u.name || u.username}{u.email ? ` (${u.email})` : ''}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Initial Status</Form.Label>
                            <Form.Select value={regStatus} onChange={e => setRegStatus(e.target.value)}>
                                <option value='registered'>Registered (Pending)</option>
                                <option value='confirmed'>Confirmed (Approved)</option>
                            </Form.Select>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' type='button' onClick={() => setShowRegModal(false)}>Cancel</Button>
                    <Button variant='dark' type='submit' form='reg-form'>Add Player</Button>
                </Modal.Footer>
            </Modal>

        </Container>
    )
}

export default TournamentEditScreen
